import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'

import * as notificationModalSelector from 'selectors/notificationModal'

import { clearNotification } from 'reducers/notificationModal'

import NotificationBar from './NotificationBar'

const ModalNotification = () => {
  const text = useSelector(notificationModalSelector.text)
  const type = useSelector(notificationModalSelector.type)
  const dispatch = useDispatch()

  const clearNotification_ = () => {
    dispatch(clearNotification())
  }

  // clear old notification on Modal mount
  useEffect(() => {
    clearNotification_()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <NotificationBar
      text={text}
      type={type}
      hideRefreshLink
      clearNotification={clearNotification_}
      dataTest='modal-notification'
    />
  )
}

export default ModalNotification
